const inputsEvents = {
  handleKeyUp(key, refetch) {
    if (key === 'Enter') {
      refetch()
    }
  }
}

export default inputsEvents;